export enum PaywallEvents {
  viewItemList = 'view_item_list',
  selectItem = 'select_item',
  beginCheckout = 'begin_checkout',
  purchase = 'purchase',
  alacarteMediaPurchaseMedia = 'a_la_carte_media_purchase_media',
}
